<template>
  <a-swiper
    :swipe-list="teamMembers"
    :custom-options="swiperOptions"
    :display-arrows="false"
    :pagination="true"
    :swiper-pagination-custom-class="$options.consts.SWIPER_PAGINATION_CLASS"
    class="team-slider__wrapper"
  >
    <team-slider-slide
      slot-scope="{ slide }"
      :team-member="slide"
      class="team-slider__slide-wrapper"
    />

    <div
      slot="bullets"
      class="swiper-pagination swiper-pagination-bullets"
      :class="$options.consts.SWIPER_PAGINATION_CLASS"
    />
  </a-swiper>
</template>

<script>
import ASwiper from 'shared/ASwiper/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import TeamSliderSlide from 'sections/_shared/TeamSlider/TeamSliderSlide/index.vue'

const SWIPER_PAGINATION_CLASS = 'team-slider__swiper-pagination-container'

export default {
  name: 'TeamSlider',
  components: { TeamSliderSlide, ASwiper },
  props: {
    teamMembers: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    SWIPER_PAGINATION_CLASS
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 30,
        pagination: {
          el: `.${SWIPER_PAGINATION_CLASS}`,
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom team-slider__swiper-pagination-item"></span>`
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.team-slider__wrapper {
  $margin-right: (
    $above-desktop-xl: -#{$padding-x-desktop-full-hd},
    $desktop-md: -#{$padding-x-desktop-md},
    $mobile: -#{$padding-x-mobile}
  );

  @include setStyleByBreakpoint('margin-right', $margin-right);

  /deep/ .swiper__custom-swiper {
    margin: 0;
  }

  .team-slider__slide-wrapper,
  /deep/ .swiper__list__item {
    $width: (
      $above-desktop-xl: 378px,
      $mobile: 255px
    );

    @include setStyleByBreakpoint('width', $width);
  }

  /deep/ .swiper__custom-swiper {
    width: 100%;
  }

  /deep/ .team-slider__swiper-pagination-item {
    background: $c--white;
    margin: 0 12px;

    &:not(.swiper-pagination-bullet-active) {
      width: 8px;
      height: 8px;
      opacity: 1;
      background: #808080;
    }
  }

  /deep/ .team-slider__swiper-pagination-container {
    position: static;
    width: auto;
    display: flex;
    align-items: center;

    $margin-top: (
      $above-desktop-xl: 64px,
      $mobile: 32px
    );

    $margin-right: (
      $above-desktop-xl: $padding-x-desktop-full-hd,
      $desktop-md: $padding-x-desktop-md,
      $mobile: $padding-x-mobile
    );

    @include setStyleByBreakpoint('margin-right', $margin-right);

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
